import {web3} from 'decentralized/web3.js';

const metamaskInstalled = false;

const bs58 = require('bs58');

export function ipfsHashToBytes32(ipfs_hash) {
    var h = bs58.decode(ipfs_hash).toString('hex').replace(/^1220/, '');
    if (h.length != 64) {
        return null;
    }
    return '0x' + h;
}

export function bytes32ToIPFSHash(hash_hex) {
    var buf = new Buffer(hash_hex.replace(/^0x/, '1220'), 'hex')
    return bs58.encode(buf)
}

export function convertAsciiToContractHex(ascii) {
    let hex = web3.utils.fromAscii(ascii);
    for (let i=hex.length; i <= 65; i++) {
        hex += '0';
    }
    return hex;
}

